import React, { useEffect, useState } from "react";
import { createStyles, Grid, Space, Stack, Text } from "@mantine/core";
import Survey from "../services/model/Survey";
import SurveyQuestion from "../services/model/SurveyQuestion";
import SurveyResponseSubmissionCard from "../elements/SurveyResponseSubmissionCard";
import Author from "../../../common/model/Author";
import SurveySummaryResponsesStack from "../elements/SurveySummaryResponsesStack";

const useStyles = createStyles(() => ({
  heading: {
    fontSize: "16px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.16px;",
    textAlign: "left",
    color: "495057",
  },
}));

type SurveyResponsesPanelProps = {
  survey: Survey;
};

const SurveyResponsesPanel: React.FC<SurveyResponsesPanelProps> = ({
  survey,
}) => {
  const { classes } = useStyles();

  const [selectedRespondent, setSelectedRespondent] = useState(() => {
    if (survey.questions[0].responses.length) {
      return survey.questions[0].responses[0].employee;
    }
    return undefined;
  });
  const [questions, setQuestions] = useState<SurveyQuestion[]>(() =>
    survey.questions
      .filter(
        (it) =>
          !!it.responses.find(
            (response) => response.employee.id === selectedRespondent?.id
          )
      )
      .map((it) => ({
        ...it,
        responses: it.responses.filter(
          (response) => response.employee.id === selectedRespondent?.id
        ),
      }))
  );

  const [respondents] = useState<Author[]>(() => {
    const $respondents: Author[] = [];
    survey.questions.forEach((question) => {
      question.responses.forEach((response) => {
        const $respondentIds = $respondents.map((it) => it.id);
        if (!$respondentIds.includes(response.employee.id)) {
          $respondents.push(response.employee);
        }
      });
    });

    return $respondents;
  });

  useEffect(() => {
    if (selectedRespondent) {
      setQuestions(
        survey.questions
          .filter(
            (it) =>
              !!it.responses.find(
                (response) => response.employee.id === selectedRespondent.id
              )
          )
          .map((it) => ({
            ...it,
            responses: it.responses.filter(
              (response) => response.employee.id === selectedRespondent.id
            ),
          }))
      );
    }
  }, [selectedRespondent]);

  return (
    <div style={{ padding: "32px 40px", background: "#f7f7f8" }}>
      <Grid
        columns={24}
        gutter="xl"
        justify="space-between"
        style={{ backgroundColor: "#f7f7f8", padding: "32px 40px" }}
      >
        <Grid.Col span={6}>
          <Text className={classes.heading}>Submissions</Text>
          <Space h="xl" />
          <Stack justify="flex-start" spacing="xl">
            {respondents.map((it) => (
              <SurveyResponseSubmissionCard
                key={`submission-${it.id}`}
                id={Number(`${it.id}`)}
                firstName={`${it.first_name}`}
                lastName={`${it.last_name}`}
                selection={selectedRespondent}
                onSelect={() => setSelectedRespondent(it)}
              />
            ))}
          </Stack>
        </Grid.Col>

        <Grid.Col span={16}>
          <Text className={classes.heading}>Responses</Text>
          <Space h="xl" />
          <SurveySummaryResponsesStack items={questions} />
        </Grid.Col>
      </Grid>
    </div>
  );
};

export default SurveyResponsesPanel;
